export default __webpack_public_path__ + "static/media/Card.7cf8a0ce.gif";